import { Grid, Typography, Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import bannerVideo from '../../images/academics/commersebanner.mp4';

const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    exit: { opacity: 0, y: -30, transition: { duration: 0.8, ease: 'easeIn' } },
};

const cards = [
    { title: 'Exploring Commerce Academics' },
    { title: 'Foundation for Innovation and Discovery' }
];

const Banner = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % cards.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Grid
            container
            spacing={0}
            sx={{
                position: 'relative',
                height: { md: '60vh', sm: '40vh', xs: '45vh' },
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            {/* Background Video */}
            <Box
                component="video"
                autoPlay
                loop
                muted
                playsInline
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: 0
                }}
            >
                <source src={bannerVideo} type="video/mp4" />
            </Box>

            {/* Dark Overlay */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(to right, rgba(26,35,126,0.8), rgba(0,0,0,0.4))',
                    zIndex: 1,
                }}
            />

            {/* Animated Content */}
            <AnimatePresence mode="wait">
                <Box
                    key={index}
                    component={motion.div}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={textVariants}
                    sx={{
                        textAlign: 'center',
                        zIndex: 2,
                        color: '#fff',
                        padding: 4,
                        position: 'relative',
                        width: '100%'
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            color: '#fff',
                            fontSize: { xs: '32px', md: '56px', sm: '44px' },
                            textShadow: '0 4px 12px rgba(0,0,0,0.5)',
                            letterSpacing: '1px'
                        }}
                    >
                        {cards[index].title}
                    </Typography>
                </Box>
            </AnimatePresence>
        </Grid>
    );
};

export default Banner;
